// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/services";
import Contact from "./pages/contact";
import Packages from "./pages/packages";
import Portfolio from "./pages/portfolio";
import Dashboard from "./pages/Dashboard";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import TermsConsent from "./pages/TermsConsent"; // صفحة الموافقة على الشروط
import TermsPrivacy from "./pages/TermsPrivacy"; // صفحة الشروط والخصوصية
import ChatBot from "./components/ChatBot";
import EmailBot from "./pages/EmailBot"; // أداة الإيميلات الذكية

function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}

function App() {
  const location = useLocation();

  const storedData = localStorage.getItem("userData") || sessionStorage.getItem("userData");
  const isAdmin = storedData ? JSON.parse(storedData).role === 'admin' : false;

  // اظهار البوت فقط في About و Portfolio
  const showBot = location.pathname === "/about" || location.pathname === "/portfolio";

  return (
    <>
      <Navbar />

      {showBot && <ChatBot />}

      <Routes>
        {/* الصفحة الرئيسية */}
        <Route path="/" element={<Home />} />

        {/* صفحات الموقع */}
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/dashboard" element={<Dashboard />} />

        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogPost />} />

        {/* أدوات إدارية وتسجيل */}
        <Route path="/email-bot" element={isAdmin ? <EmailBot /> : <Navigate to="/" />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />

        {/* صفحة الشروط والموافقة */}
        <Route path="/terms-consent" element={<TermsConsent />} />

        {/* صفحة Terms & Privacy */}
        <Route path="/terms-privacy" element={<TermsPrivacy />} />

        {/* أي رابط غير موجود يرجع للهوم */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>

      <Footer />
    </>
  );
}

export default AppWrapper;